module.exports = __webpack_public_path__ + "blissweb-md.a07d894373639c29f4da.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Md/blissweb-md.woff
// module id = 479
// module chunks = 5